import PropTypes from 'prop-types';
import { Constants } from '@bingads-webui-clientcenter/address';

export const DefaultBusinessNameMinLength = 2;
export const DefaultBusinessNameMaxLength = Constants.BusinessNameMaxLength;
export const DefaultPhoneNumberMinLength = 1;
export const DefaultPhoneNumberMaxLength = 50;

export const TaxDataPropTypes = PropTypes.arrayOf(PropTypes.shape({
  Key: PropTypes.string.isRequired,
  Value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
}));

export const TaxCertificationPropTypes = PropTypes.shape({
  TaxCertifications: PropTypes.arrayOf(PropTypes.shape({
    Key: PropTypes.string,
    Value: PropTypes.instanceOf(File),
  })),
  ExecutionDate: PropTypes.string,
  TaxCertificationBlobName: PropTypes.string,
  Status: PropTypes.number,
});
